import React, { Component } from 'react';
import Button from '../common/Button';
import moment from 'moment';
import { Link } from 'react-router';
import { appBasePath } from '../../constants/staticData';

class SliderHeader extends Component {
  render() {
    const {
      requestDetails,
      modalClose,
      nextSliderCallback,
      previousSliderCallback,
      showNextButton,
      showPreviousButton,
      actions,
      router,
      declineAJobCallback
    } = this.props;
    const jobStatus = requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    const serviceType = requestDetails.serviceType.replace(/\s+/, "").toLowerCase();
    return (
      <div className={"jm-header " + serviceType}>
        <div className="sliderHeader">
          <div className="sliderNavigation">
            <span className={showPreviousButton ? "" : "disabled"} onClick={previousSliderCallback}><i className="mdi mdi-chevron-left" /></span>
            <span className={showNextButton ? "" : "disabled"} onClick={nextSliderCallback}><i className="mdi mdi-chevron-right" /></span>
          </div>
          <div className="job-slider-title">
            <label>
              Request ID : {requestDetails.requestid}
              <Link to={`${appBasePath}/job/${requestDetails.userbookingrequestId}`}><i className="mdi mdi-launch"></i></Link>
            </label>
            <span>{requestDetails.createdAt}</span>
            {/*<i className="mdi mdi-launch"></i>*/}
          </div>
          <div className="slider-btn-right">
            {(jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed') && <Button btnSize="sm" btnType="transparent" fontSize={13} btnCallBack={declineAJobCallback} label="Decline Job" />}
            {jobStatus != 'waiting' && jobStatus != 'completed'  && jobStatus != 'closed' && <Button btnSize="sm" fontSize={13} label="Message" btnCallBack={(e) => {e.preventDefault(); router.push(`${appBasePath}/job/${requestDetails.userbookingrequestId}?current_tab=messages`) }} btnType={(jobStatus == 'waiting' || jobStatus == 'in progress' || jobStatus == 'inprogress') ? 'transparent' : 'red'} />}
            {jobStatus == 'inprogress' || jobStatus == 'in progress' && <Button btnSize="sm" fontSize={13} label="View Quote" btnType="red" btnCallBack={(e) => { e.preventDefault(); router.push(`${appBasePath}/job/${requestDetails.userbookingrequestId}`) }}/>}
            {jobStatus == 'waiting' &&
            <Button btnCallBack={
              (e) => {
                e.preventDefault();
                console.log('What are the props ', this.props);
                console.log('PATH ..', `${appBasePath}/job/${requestDetails.userbookingrequestId}`);
                router.push(`${appBasePath}/job/${requestDetails.userbookingrequestId}`);
                }}
                style={{ 'width': '115px' }}
                btnSize="sm" btnType="red" fontSize={13} label="Create Quote" />}
            <span className="jobSlider-close" onClick={modalClose}><i className="mdi mdi-close" /></span>
          </div>
        </div>
      </div>
    );
  }
}

export default SliderHeader;



// WEBPACK FOOTER //
// ./src/components/JobSliderView/SliderHeader.jsx